import { lazy } from 'react';
import { createBrowserRouter, Navigate } from 'react-router-dom';
import MainLayout from '@/components/layout/MainLayout';

// 懒加载页面
const Dashboard = lazy(() => import('@/pages/Dashboard'));
const TenantList = lazy(() => import('@/pages/TenantList'));
const TenantConfig = lazy(() => import('@/pages/TenantConfig'));
const Sessions = lazy(() => import('@/pages/Sessions'));
const Users = lazy(() => import('@/pages/Users'));
const Statistics = lazy(() => import('@/pages/Statistics'));
const Settings = lazy(() => import('@/pages/Settings'));

/**
 * 路由配置
 */
export const router = createBrowserRouter([
  {
    path: '/',
    element: <MainLayout />,
    children: [
      { index: true, element: <Dashboard /> },
      { path: 'tenants', element: <TenantList /> },
      { path: 'tenants/:tenantId/config', element: <TenantConfig /> },
      { path: 'sessions', element: <Sessions /> },
      { path: 'users', element: <Users /> },
      { path: 'statistics', element: <Statistics /> },
      { path: 'settings', element: <Settings /> },
      { path: '*', element: <Navigate to="/" replace /> },
    ],
  },
]);
